import { useEffect, useState } from "react";

export default function DataDeletionStatus() {
  const [status, setStatus] = useState("loading");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    if (!id) {
      setStatus("missing");
      return;
    }
    setCode(id);
    const backend = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${backend}/api/meta/data-deletion/status?id=${encodeURIComponent(id)}`)
      .then(r => r.ok ? r.json() : Promise.reject(r))
      .then(d => setStatus(d.status || "processing"))
      .catch(() => { setStatus("error"); setError("Request not found or expired."); });
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f0fdf4 0%, #ffffff 60%)",
      padding: "48px 24px",
      fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      color: "#111827"
    }}>
      <div style={{ maxWidth: 620, margin: "0 auto" }} dir="ltr" data-testid="deletion-status-page">
        <a href="/" style={{ color: "#047857", textDecoration: "none", fontWeight: 600 }}>← SocialHub</a>
        <h1 style={{ fontSize: 32, fontWeight: 800, marginTop: 24 }}>Data Deletion Request</h1>

        {status === "loading" && <p>Checking status…</p>}

        {status === "processing" && (
          <div style={{ background: "#ecfdf5", padding: 20, borderRadius: 12, marginTop: 16 }}>
            <p style={{ margin: 0, fontWeight: 600, color: "#047857" }}>✓ Request received</p>
            <p style={{ marginTop: 8, color: "#374151" }}>
              We have received your data deletion request. Your Meta-related data (tokens, connected pages,
              inbox mapping) has been queued for permanent deletion and will be fully purged within 30 days.
            </p>
            <p style={{ marginTop: 12, color: "#6b7280", fontSize: 14 }}>Confirmation code:</p>
            <code style={{ background: "#fff", padding: "6px 10px", borderRadius: 6, fontSize: 14 }}>{code}</code>
          </div>
        )}

        {status === "missing" && <p style={{ color: "#b91c1c" }}>No confirmation code provided.</p>}
        {status === "error" && <p style={{ color: "#b91c1c" }}>{error}</p>}

        <p style={{ marginTop: 24, color: "#6b7280", fontSize: 14 }}>
          Questions? Contact <a href="mailto:support@letsm.io" style={{ color: "#047857" }}>support@letsm.io</a>.
        </p>
      </div>
    </div>
  );
}
